import { createSimpleFunctional } from '@/util'

export const VListItemSubtitle = createSimpleFunctional('v-list-item-subtitle')

export type VListItemSubtitle = InstanceType<typeof VListItemSubtitle>
